<template>
  <ApplicationLayout>
    <v-container
      fluid
      px-12
      py-6
    >
      <BackTitle
        title="Configs"
      ></BackTitle>

      <v-card
        class="pa-6 mt-6"
      >
        <v-form
          @submit.prevent="submit()"
          ref="form"
          v-model="valid"
        >
          <h2 class="headline">Home meta description</h2>

          <v-row>
            <v-col>
              <v-textarea
                v-model="config.home_meta_description"
                label="Home meta description"
              ></v-textarea>
            </v-col>
          </v-row>

          <h2 class="headline">Home banner</h2>

          <v-row>
            <v-col
              cols="6"
              class="px-6"
            >
              <v-text-field
                v-model="config.home_banner_text"
                label="Text"
              ></v-text-field>

              <Combobox
                v-model="config.home_banner_page"
                :select-props="{
                  items: _pages,
                  label: 'Target page'
                }"
              ></Combobox>
            </v-col>

            <v-col
              cols="6"
              class="px-6"
            >
              <TextFieldImage
                label="Image"
                v-model="config.home_banner"
                name="homeBanner"
              ></TextFieldImage>

              <TextFieldImage
                label="Image (small)"
                v-model="config.home_banner_small"
                name="homeBannerSmall"
              ></TextFieldImage>
            </v-col>
          </v-row>

          <h2 class="headline">Home banner ad</h2>

          <v-row>
            <v-col
              cols="6"
              class="px-6"
            >
              <v-text-field
                v-model="config.home_banner_ad_url"
                label="Ad url"
              ></v-text-field>
            </v-col>

            <v-col
              cols="6"
              class="px-6"
            >
              <v-text-field
                v-model="config.home_banner_ad_img"
                label="Ad image"
              ></v-text-field>
            </v-col>
          </v-row>

          <h2 class="headline">Home products highlights</h2>

          <v-row>
            <v-col
              cols="6"
              class="px-6"
            >
              <v-text-field
                v-model="config.home_products_1_text"
                label="Line 1 text"
              ></v-text-field>

              <Combobox
                v-model="config.home_products_1_page"
                :select-props="{
                  items: _pages,
                  label: 'Line 1 page'
                }"
              ></Combobox>
            </v-col>

            <v-col
              cols="6"
              class="px-6"
            >
              <v-text-field
                v-model="config.home_products_2_text"
                label="Line 2 text"
              ></v-text-field>

              <Combobox
                v-model="config.home_products_2_page"
                :select-props="{
                  items: _pages,
                  label: 'Line 2 page'
                }"
              ></Combobox>
            </v-col>
          </v-row>

          <h2 class="headline">Home pages higlight</h2>

          <v-row>
            <v-col
              cols="6"
              class="px-6"
            >
              <Combobox
                v-model="config.home_pages_1"
                :select-props="{
                  items: _pages,
                  label: 'Page 1'
                }"
              ></Combobox>

              <Combobox
                v-model="config.home_pages_2"
                :select-props="{
                  items: _pages,
                  label: 'Page 2'
                }"
              ></Combobox>
            </v-col>

            <v-col
              cols="6"
              class="px-6"
            >
              <Combobox
                v-model="config.home_pages_3"
                :select-props="{
                  items: _pages,
                  label: 'Page 3'
                }"
              ></Combobox>

              <Combobox
                v-model="config.home_pages_4"
                :select-props="{
                  items: _pages,
                  label: 'Page 4'
                }"
              ></Combobox>
            </v-col>
          </v-row>

          <h2 class="headline">Home bottom ad</h2>

          <v-row>
            <v-col
              cols="6"
              class="px-6"
            >
              <v-text-field
                v-model="config.home_bottom_ad_url"
                label="Bottom ad url"
              ></v-text-field>
            </v-col>

            <v-col
              cols="6"
              class="px-6"
            >
              <v-text-field
                v-model="config.home_bottom_ad_img"
                label="Bottom ad image"
              ></v-text-field>
            </v-col>
          </v-row>

          <h2 class="headline">Home footer</h2>

          <v-row>
            <v-col
              class="px-6"
            >
              <v-text-field
                v-model="config.home_footer_title"
                label="Footer title"
              ></v-text-field>

              <v-textarea
                v-model="config.home_footer_text"
                label="Footer text"
              ></v-textarea>
            </v-col>
          </v-row>

          <h2 class="headline">Menu ads</h2>

          <v-row>
            <v-col
              cols="6"
              class="px-6"
            >
              <v-text-field
                v-model="config.menu_ad_url"
                label="Menu ad url"
              ></v-text-field>

              <v-text-field
                v-model="config.menu_optional_ad_url"
                label="Menu optional ad url"
              ></v-text-field>

              <v-text-field
                v-model="config.menu_mobile_ad_url"
                label="Menu mobile ad url"
              ></v-text-field>
            </v-col>

            <v-col
              cols="6"
              class="px-6"
            >
              <v-text-field
                v-model="config.menu_ad_img"
                label="Menu ad image"
              ></v-text-field>

              <v-text-field
                v-model="config.menu_optional_ad_img"
                label="Menu optional ad image"
              ></v-text-field>

              <v-text-field
                v-model="config.menu_mobile_ad_img"
                label="Menu mobile ad image"
              ></v-text-field>
            </v-col>
          </v-row>

          <h2 class="headline">Deals</h2>

          <v-row>
            <v-col
              cols="6"
              class="px-6"
            >
              <TextFieldImage
                label="Image"
                v-model="config.deals_banner"
                name="dealsBanner"
              ></TextFieldImage>
            </v-col>

            <v-col
              cols="6"
              class="px-6"
            >
              <TextFieldImage
                label="Image (small)"
                v-model="config.deals_banner_small"
                name="dealsBannerSmall"
              ></TextFieldImage>
            </v-col>
          </v-row>

          <v-row
            justify="end"
          >
            <v-btn
              :disabled="!valid"
              color="primary"
              type="submit"
              depressed
            >Save</v-btn>
          </v-row>
        </v-form>
      </v-card>
    </v-container>
  </ApplicationLayout>
</template>

<script>
import { mapState } from 'vuex'

import ApplicationLayout from '../components/layouts/ApplicationLayout.vue'
import BackTitle from '../components/BackTitle.vue'
import TextFieldImage from '../components/TextFieldImage.vue'
import Combobox from '../components/Combobox.vue'

export default {
  components: {
    ApplicationLayout,
    BackTitle,
    TextFieldImage,
    Combobox
  },
  data() {
    return {
      valid: false
    }
  },
  computed: {
    ...mapState('Global', ['config']),
    ...mapState('Pages', ['pages']),
    _pages() {
      return this.pages.map(page => ({
        text: this.$filters.striptags(page.title),
        value: page.id.toString()
      }))
    }
  },
  async created() {
    this.$store.dispatch('Global/getConfig')
    this.$store.dispatch('Pages/getAll')
  },
  methods: {
    async submit() {
      if (!this.$refs.form.validate()) return
      const snackbar = { text: 'Config update succeed' }
      try {
        await this.$store.dispatch('Global/updateConfig')
      } catch (error) {
        snackbar.text = 'Config update failed'
        snackbar.color = 'error'
      }
      this.$store.commit('Global/setSnackbar', snackbar)
    }
  }
}
</script>
